// RECENT ACTIVITY — the party page Overview's newest entries, in the Statement tab's own rows (StatementList), from the
// same read (statementRead.ts) over the last 90 days (his words, 1 Nov 2026: "not aligned with other statement+recent
// activity"). The route pages oldest first, so every page of the window is read before the newest five are drawn — never
// "Long history — the newest is on the Statement" in their place. A failed read is one line with Try again; "Nothing in
// the last 90 days" needs a read that answered whole.
import { Link } from 'react-router-dom';
import { Panel, ReadFailed, SkeletonRows, EmptyState, StateLine, TAP } from '../kit';
import { daysAgo, usePartyJournal } from './statementRead';
import { StatementList } from './StatementList';
import type { JournalRow } from './journal';

export const RECENT_DAYS = 90;
export const RECENT_SHOWN = 5;

export function RecentActivity({ slug, entity, balances, statementHref, onOpen, self, dealLifecycle }: {
  self?: string;
  dealLifecycle?: (id: string) => string | null | undefined;
  slug: string;
  entity: string;
  balances: Record<string, number>;
  statementHref: string;
  onOpen: (r: JournalRow) => void;
}) {
  const read = usePartyJournal(slug, entity, balances, { from: daysAgo(RECENT_DAYS) });
  const newest = read.journal.filter((r) => r.txn_id !== null).slice(0, RECENT_SHOWN);
  const full = <Link to={statementHref} className={TAP}>Full statement →</Link>;

  return (
    <Panel title="Recent activity" flush action={full}>
      {read.state === 'failed' && !read.pageFailed ? (
        <div className="px-4 py-3 lg:px-5"><ReadFailed what="the statement" error={read.error} onRetry={read.refetch} tone="bad" /></div>
      ) : read.pageFailed ? (
        // The newest are on the page that failed: nothing older is passed off as recent.
        <div className="px-4 py-3 lg:px-5"><ReadFailed what="the newest entries" error={read.error} onRetry={read.fetchRest} tone="bad" /></div>
      ) : read.capped ? (
        <div className="px-4 py-4 lg:px-5"><StateLine>Too many to read here — see the Statement.</StateLine></div>
      ) : !read.complete ? (
        <SkeletonRows rows={3} what="the statement" />
      ) : newest.length === 0 ? (
        <EmptyState>Nothing in the last {RECENT_DAYS} days.</EmptyState>
      ) : (
        <StatementList rows={newest} onOpen={onOpen} label="Recent activity" self={self} dealLifecycle={dealLifecycle} />
      )}
    </Panel>
  );
}
